import { urls } from 'shared/constants/routing.constants';

export const FOOTER_LINKS_TEXT = {
  about: 'About',
  B2B: 'B2B',
  privacyPolicy: 'Privacy policy',
  termsAndConditions: 'Terms & Conditions',
  ConsentToDataProcessing: 'Consent to data processing',
  communityGuidelines: 'Community Guidelines',
  email: 'info@deb8.tv',
  copyright: '© 2025 Deb8.TV',
} as const;

export const FOOTER_SOCIAL_LINKS = [
  {
    icon: 'icon-discord',
    href: urls.otherLinks.socialLinks.discord,
  },
  {
    icon: 'icon-twitter',
    href: urls.otherLinks.socialLinks.twitter,
  },
];

export const FOOTER_LINKS = [
  {
    text: FOOTER_LINKS_TEXT.privacyPolicy,
    href: urls.commonPages.privacyPolicy,
  },
  {
    text: FOOTER_LINKS_TEXT.termsAndConditions,
    href: urls.commonPages.termsAndConditions,
  },
  {
    text: FOOTER_LINKS_TEXT.ConsentToDataProcessing,
    href: urls.commonPages.ConsentToDataProcessing,
  },
  {
    text: FOOTER_LINKS_TEXT.communityGuidelines,
    href: urls.commonPages.communityGuidelines,
  },
];
